"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileNameResolver = void 0;
class FileNameResolver {
    constructor(resolveWordBaseName, settingsBaseName, markersBaseName) {
        this.resolveWordBaseName = resolveWordBaseName;
        this.settingsBaseName = settingsBaseName;
        this.markersBaseName = markersBaseName;
    }
    static createDefault() {
        const resolveWordBaseName = function (uniqueName) {
            const match = uniqueName.match(/^(\+)?(.+?)(\+)?(~*)$/);
            if (match) {
                let modifier = "";
                if (match[1]) {
                    modifier += "S";
                }
                if (match[3]) {
                    modifier += "P";
                }
                if (match[4].length > 0) {
                    modifier += (match[4].length + 1).toString();
                }
                if (modifier.length > 0) {
                    modifier = "_" + modifier;
                }
                const fileName = match[2] + modifier;
                return fileName;
            }
            else {
                throw new Error("cannot happen");
            }
        };
        const settingsBaseName = "#SETTINGS";
        const markersBaseName = "#MARKERS";
        const resolver = new FileNameResolver(resolveWordBaseName, settingsBaseName, markersBaseName);
        return resolver;
    }
}
exports.FileNameResolver = FileNameResolver;
